export enum EligibilityCriteriaProperties {
    IS_ON_PARENTAL_LEAVE = 'isOnParentalLeave',
    IS_PART_TIME = 'isPartTime',
    IS_DISABLED = 'isDisabled',
    IS_SHIFT_WORKER = 'isShiftWorker',
    IS_SINGLE_PARENT = 'isSingleParent',
    IS_CAREGIVER = 'isCaregiver',
    IS_ELIGIBLE = 'isEligible'
}
